var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline",on:{"click":function($event){return _vm.openDrawer()}}},[_vm._t("activator")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }